import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./styles.module.css";
import darkLogo from "../../../../logo-contact-white.svg";

const LIGHT_LOGO_SRC =
  "https://epinics.com/static/media/logo-contact.7e2887bc289aad2327275ee13a3a4a50.svg";

const links = [
  { href: "tel:+94741041212", label: "Phone", icon: "phone" },
  { href: "https://wa.me/94741041212", label: "WhatsApp", icon: "whatsapp" },
  { href: "mailto:info@epinics.com", label: "Email", icon: "email" },
  { href: "https://epinics.com/", label: "Website", icon: "globe" },
  { href: "https://www.facebook.com/epinicspos", label: "Facebook", icon: "facebook" },
  { href: "https://www.linkedin.com/company/epinics", label: "LinkedIn", icon: "linkedin" },
  { href: "https://www.tiktok.com/@epinicspos0", label: "TikTok", icon: "tiktok" },
  { href: "https://www.youtube.com/@EpinicsPOS", label: "YouTube", icon: "youtube" },
  { href: "https://www.instagram.com/epinics_pos", label: "Instagram", icon: "instagram" },
  { href: "https://t.me/+94741041212", label: "Telegram", icon: "telegram" },
];

const primaryIcons = ["phone", "whatsapp", "email", "globe"];
const contactValueMap = {
  phone: "+94 74 104 1212",
  whatsapp: "WhatsApp",
  email: "info@epinics.com",
  globe: "epinics.com",
};

const iconProps = { width: 18, height: 18, fill: "currentColor" };

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12S0 5.446 0 12.073c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.265.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.058 1.645-.07 4.849-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const iconMap = {
  phone: PhoneIcon,
  whatsapp: WhatsAppIcon,
  email: EmailIcon,
  globe: GlobeIcon,
  facebook: FacebookIcon,
  linkedin: LinkedInIcon,
  tiktok: TikTokIcon,
  youtube: YouTubeIcon,
  instagram: InstagramIcon,
  telegram: TelegramIcon,
};

const Footer = ({ themeMode }) => {
  const primaryLinks = links.filter(({ icon }) => primaryIcons.includes(icon));
  const socialLinks = links.filter(({ icon }) => !primaryIcons.includes(icon));
  const logoSrc = themeMode === "dark" ? darkLogo : LIGHT_LOGO_SRC;

  return (
    <footer className={styles.siteFooter}>
      <div className={styles.footerContainer}>
        <div className={styles.footerTop}>
          <div className={styles.footerBrand}>
            <img
              key={themeMode}
              src={logoSrc}
              alt="Epinics"
              className={styles.logo}
            />
            <div className={styles.brandContent}>
              <h2 className={styles.brandName}>EPINICS POS</h2>
              <p className={styles.tagline}>
                Reliable POS technology for modern retail and hospitality teams.
              </p>
            </div>
          </div>

          <div className={styles.contactGrid}>
            {primaryLinks.map(({ href, label, icon }) => {
              const Icon = iconMap[icon];
              const isExternal = href.startsWith("http");
              return (
                <a
                  key={icon}
                  href={href}
                  {...(isExternal && { target: "_blank", rel: "noopener noreferrer" })}
                  className={styles.contactCard}
                >
                  <span className={styles.contactIcon} aria-hidden="true">
                    {Icon ? <Icon /> : null}
                  </span>
                  <span className={styles.contactText}>
                    {contactValueMap[icon] || label}
                  </span>
                </a>
              );
            })}
          </div>
        </div>

        <div className={styles.footerDivider} />

        <div className={styles.footerBottom}>
          <ul className={styles.socialIcons}>
            {socialLinks.map(({ href, label, icon }) => {
            const Icon = iconMap[icon];
            const isExternal = href.startsWith("http");
            return (
              <li key={icon}>
                <a
                  href={href}
                  {...(isExternal && { target: "_blank", rel: "noopener noreferrer" })}
                  aria-label={label}
                  className={styles.socialLink}
                >
                  {Icon ? <Icon /> : null}
                </a>
              </li>
            );
            })}
          </ul>
          <p className={styles.copyright}>
            Copyright &copy; {new Date().getFullYear()} Epinics (Pvt) Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  themeMode: PropTypes.oneOf(["light", "dark"]),
};

const mapStateToProps = (state) => ({
  themeMode: state.theme?.mode ?? "light",
});

export default connect(mapStateToProps)(Footer);
